<template>

  <div class="container">
    <div id="loader" style="margin:0 auto; width:68px;">
      <svg width="68px" height="80px" viewBox="0 0 68 80" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Ideas" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Scrubbrush-Top-Pills-Copy" transform="translate(-1222.000000, -788.000000)" fill="#CCCCCC">
            <g id="Group-3" transform="translate(1222.000000, 788.000000)">
              <path d="M0.00419495803,18 L2.40419496,76 C2.50419496,78.2 4.40419496,80 6.60419496,80 L60.504195,80 C62.704195,80 64.604195,78.2 64.704195,76 L67.304195,18 L0.00419495803,18 Z M33.604195,70.7 C20.904195,70.7 10.604195,60.4 10.604195,47.7 C10.604195,35 20.904195,24.7 33.604195,24.7 C46.304195,24.7 56.604195,35 56.604195,47.7 C56.604195,60.4 46.304195,70.7 33.604195,70.7 Z M63.404195,12 L63.204195,12 L61.504195,0 L5.70419496,0 L4.00419496,12 L3.80419496,12 C1.60419496,12 -0.095805042,14 0.00419495803,16.2 L0.00419495803,17 L67.304195,17 L67.304195,16.2 C67.404195,14 65.604195,12 63.404195,12 Z M54.904195,4.8 C56.104195,4.8 57.104195,5.8 57.104195,7 C57.104195,8.2 56.104195,9.2 54.904195,9.2 C53.704195,9.2 52.704195,8.2 52.704195,7 C52.704195,5.8 53.704195,4.8 54.904195,4.8 Z M47.904195,4.8 C49.104195,4.8 50.104195,5.8 50.104195,7 C50.104195,8.2 49.104195,9.2 47.904195,9.2 C46.704195,9.2 45.704195,8.2 45.704195,7 C45.704195,5.8 46.704195,4.8 47.904195,4.8 Z M41.104195,4.8 C42.304195,4.8 43.304195,5.8 43.304195,7 C43.304195,8.2 42.304195,9.2 41.104195,9.2 C39.904195,9.2 38.904195,8.2 38.904195,7 C38.904195,5.8 39.904195,4.8 41.104195,4.8 Z M18.704195,8.9 C18.704195,9.5 18.204195,10 17.604195,10 L11.804195,10 C11.204195,10 10.704195,9.5 10.704195,8.9 L10.704195,6.1 C10.704195,5.5 11.204195,5 11.804195,5 L17.604195,5 C18.204195,5 18.704195,5.5 18.704195,6.1 L18.704195,8.9 Z" id="Shape" fill-rule="nonzero"></path>
              <path class="rotating" d="M51.804195,53.2 C49.404195,61 42.204195,66.6 33.604195,66.6 C23.104195,66.6 14.604195,58.1 14.604195,47.6 C14.604195,44.9 15.204195,42.4 16.204195,40 C26.604195,35.6 35.004195,59.8 51.804195,53.2 L51.804195,53.2 Z" id="Path-Copy"></path>
            </g>
          </g>
        </g>
      </svg>
    </div>
    <div id="room-view">
      <div class="row center">
        <div class="column" v-if="showLeftColumn">
          <div id="info">
            <img class="hero-logo" v-bind:src="roomLogo" v-if="roomLogo">
            <h3>{{roomName}}</h3>
          </div>
          <div id="clock" v-if="showClock"></div>
          <div id="legend" v-if="showLegend">
            <h4 class="available">Available</h4>
            <h4 class="in_use">In Use</h4>
            <h4 class="complete">Complete</h4>
            <h4 class="error">Error</h4>
            <h4 class="offline">Offline</h4>
          </div>
        </div>
        <div class="column">
          <div id="canvas-container">
            <div ref="container" id="wa-container"></div>
            <canvas id="c" v-bind:width="gridSizePx" v-bind:height="gridSizePx" style="_visibility:hidden"></canvas>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import moment from "moment";

let canvas;
let layoutObj;
const grid = 20;
const gridWidth = 20;
const gridHeight = 20;
const gridRows = 40;
const gridColumns = 40;
const almostDoneThreshold = 240; // Seconds until cycle complete
let $container;
let k;
let x;
let y;
let theme = 'default';
let timerObject;

let roomSettings = {
  canvasResize: false,
  backgroundColor: "",
  hasBackgroundImage: false,
  canvas: {
    top: null,
    bottom: null,
    left: null,
    right: null,
    padding: 20,
  }
};

// Track pending async asset loads to prevent race conditions
let pendingAssetLoads = 0;
let canvasResizeNeeded = false;
let machineUpdateNeeded = false;
let vueComponentInstance = null;
let latestMachineData = null;

function startAssetLoad() {
  pendingAssetLoads++;
}

function completeAssetLoad() {
  pendingAssetLoads--;
  if (pendingAssetLoads === 0) {
    if (canvasResizeNeeded) {
      canvasResizeNeeded = false;
      canvasSizeUpdate();
    }

    // Force machine update if status updates arrived while assets were loading
    if (machineUpdateNeeded && vueComponentInstance && latestMachineData) {
      machineUpdateNeeded = false;
      // Use setTimeout to ensure canvas is fully rendered
      setTimeout(() => {
        vueComponentInstance.machineUpdate(latestMachineData);
      }, 0);
    }
  }
}

function requestCanvasResize() {
  if (pendingAssetLoads === 0) {
    canvasSizeUpdate();
  } else {
    canvasResizeNeeded = true;
  }
}

function resetCanvasBounds() {
  roomSettings.canvas.top = null;
  roomSettings.canvas.bottom = null;
  roomSettings.canvas.left = null;
  roomSettings.canvas.right = null;
}

function getMachineTypeAbbrev(machineType) {
  let id = Number(machineType.id);

  // First we try to find the type based on the machine type id
  // Taken from machine-types model
  const dryerIds = [20, 21, 22, 23, 24];
  const dryerStackIds = [22, 23, 24];
  const tumblerIds = [30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51];
  const tumblerStackIds = [33, 34, 35, 37, 38, 39, 51, 52, 53];
  const extractorIds = [100, 101, 102, 103, 104, 105, 106, 107, 108, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 151, 152,
    242, 243, 244, 245, 246, 247, 248, // MC10 machines
    255, 256, 257, 258, 259, 260, 261, 262, 263 // Mid/Large MC10 OPL machines
  ];
  const toploadIds = [0];
  const frontloadIds = [10];

  if (dryerStackIds.includes(id)) {
    return 'dry-stack';
  }
  if (dryerIds.includes(id)) {
    return 'dry';
  }
  if (tumblerStackIds.includes(id)) {
    return 'tum-stack';
  }
  if (tumblerIds.includes(id)) {
    return 'tum';
  }
  if (extractorIds.includes(id)) {
    return 'wx';
  }
  if (toploadIds.includes(id)) {
    return 'tlw';
  }
  if (frontloadIds.includes(id)) {
    return 'flw';
  }

  // If the ID is not found, we try to find the type based on the machine typeName
  const typeName = (machineType.typeName || "").toLowerCase();

  if (typeName.includes('dryer')) {
    return 'dry';
  }
  if (typeName.includes('tumbler')) {
    return 'tum';
  }
  if (typeName.includes('extractor')) {
    return 'wx';
  }
  if (typeName.includes('frontload')) {
    return 'flw';
  }
  if (typeName.includes('topload')) {
    return 'tlw';
  }

  // And finally we'll fall back to isDryer/isWasher
  if (machineType.isDryer) {
    return 'tum';
  }

  if (machineType.isWasher) {
    return 'wx';
  }

  // And if none of that works...
  console.warn('Could not find machine type abbreviation for a machine');
  return 'unknown';
}

function hasWindow(modelNumber) {
  // Dryer has a window if the 8th character of model is W
  return (modelNumber && modelNumber.length > 7 && modelNumber[7] === 'W') ? true : false;
}

function hasRearControls(modelNumber) {
  // FLW and DRY have rear controls if the 6th character of model is R
  return (modelNumber && modelNumber.length > 5 && modelNumber[5] === 'R') ? true : false;
}

function createMachine(machine, machineStatus, themeConfig) {
  let self = this;
  let color;

  let machineId = machine.id;
  let machineName = machine.machineName;
  let machineNumber = machine.machineNumber.replace(/^0+/, "");

  if (machine) {
    color = statusColor(machineStatus, themeConfig);
  } else {
    color = statusColor('', themeConfig);
  }

  const modelNumber = machine.modelNumber || "";
  let machineIcon = getMachineTypeAbbrev({
    id: machine.machineType.id,
    isDryer: machine.isDryer,
    isWasher: machine.isWasher,
    machineType: machine.machineType
  });

  let machineAuditType = machine.machineAuditType;
  let svgIcon;

  if (hasRearControls(modelNumber)) {
    machineIcon += "-back";
  }
  if (hasWindow(modelNumber)) {
    machineIcon += "-window";
  }

  let theme = themeConfig.name;
  if (machineAuditType && Object.prototype.hasOwnProperty.call(themeConfig, machineAuditType)) {
    // Icons specific to the machine audit type
    svgIcon = `themes/${theme}/${themeConfig[machineAuditType][machineIcon]}`;
  } else {
    svgIcon = `themes/${theme}/${themeConfig.icons[machineIcon]}`;
  }

    startAssetLoad();

  // Add timeout to prevent hanging if SVG fails to load
  let svgLoadTimeout = setTimeout(() => {
    console.warn('SVG load timeout for:', `/static/${svgIcon}.svg`);
    completeAssetLoad();
  }, 10000); // 10 second timeout

  fabric.loadSVGFromURL(`/static/${svgIcon}.svg`, (objects, options) => {
    clearTimeout(svgLoadTimeout);
    let group;
    let obj = fabric.util.groupSVGElements(objects, options);
    let left = machine.washAlertXAxis;
    let top = machine.washAlertYAxis;
    let scaleX = machine.washAlertScaleX || 1;
    let scaleY = machine.washAlertScaleY || 1;
    let angle = machine.washAlertAngle || 0;
    let zIndex = machine.washAlertZIndex || 1;

    let rotationAngle = 0;
    let flipX = false;
    let flipY = false;
    let leftTextOffset = 0;
    let topTextOffset = 0;
    let textInSVG = false;

    obj.set({
      left,
      top,
      width: gridWidth,
      height: gridWidth,
      fill: "rgb(127, 140, 141)",
      originX: "left",
      originY: "top",
      borderColor: "white",
      centeredRotation: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: true,
      hasControls: true,
      cornerSize: 8,
      hasBorders: false,
      padding: 0,
      scaleX: 1,
      scaleY: 1
    });

        // sets the color of the svg object to the right status color
    function updateColors(obj) {
      if (obj.fill == '#ccc' || obj.id == 'fill-#ccc') {
        obj.set({ fill: color[0] });
      } else if (obj.fill == '#aaa' || obj.id == 'fill-#aaa') {
        obj.set({ fill: color[1] });
      }

      if (obj.stroke == '#ccc' || obj.id == 'stroke-#ccc') {
        obj.set({ stroke: color[0] });
      } else if (obj.stroke == '#aaa' || obj.id == 'stroke-#aaa') {
        obj.set({ stroke: color[1] });
      }
    }

    updateColors(obj);

    // also check sub shapes to the right status color
    for (let x in obj._objects) {
      updateColors(obj._objects[x]);

      if (obj._objects[x].text == '123' || obj._objects[x].text === '--') { // '123' was used in the past, but resembles real data if it gets displayed. Now using '--' as the placeholder.
        textInSVG = true;
        obj._objects[x].text = getIconText();
      }
    }

    function getIconText() {
      let iconText = machineNumber.replace(/^0+/, "");
      iconText = machineNumber.replace(/^#/, "");
      if (machineName.length < 8) {
        iconText = machineName;
      }
      return iconText;
    }

    if (!textInSVG) {

      // Text positioning is stored in the theme.json file
      const textConfig = themeConfig.text;
      const textAlign = (textConfig) ? (textConfig["text-align"] || "center") :  "center";
      const fontFamily = (textConfig) ? (textConfig["font-family"] || "Arial, Helvetica") :  "Arial, Helvetica";
      const shadow = (textConfig) ? (textConfig["shadow"] || "rgba(0,0,0,1) 0px 0px 1px") :  "rgba(0,0,0,1) 0px 0px 1px";
      const fill = (textConfig) ? (textConfig["fill"] || "white") :  "white";
      const fontSize = (textConfig) ? (textConfig["font-size"] || 3) :  3;
      const timerFontSize = (textConfig) ? (textConfig["timer-font-size"] || 3) :  3;

      let text = new fabric.Textbox(getIconText(), {
        fontSize,
        textAlign,
        fill,
        fontFamily,
        shadow
      });

      const verticalAlign = (textConfig) ? (textConfig["vertical-align"] || "top") : "top";

      // Padding values are used to move the text down/up from the top/bottom borders of the icon
      const paddingTop = (textConfig && textConfig["padding-top"]) ? textConfig["padding-top"] : 0;
      const paddingBottom = (textConfig && textConfig["padding-bottom"]) ? textConfig["padding-bottom"] : 0;

      // Padding values are used to reduce the text width to center it on 3-D icons
      const paddingRight = (textConfig && textConfig["padding-right"]) ? textConfig["padding-right"] : 0;
      const paddingLeft = (textConfig && textConfig["padding-left"]) ? textConfig["padding-left"] : 0; // Not usually used

      let textTop, textLeft;
      if (verticalAlign === "top") {
        textTop = top + paddingTop;
      } else {
        textTop = top + gridWidth - paddingBottom;
      }

      // If the left is adjusted, we also need to reduce the width or the group (text + icon) will be offset incorrectly
      let textWidth = gridWidth - paddingRight - paddingLeft;

      text.set({
        top: textTop,
        left,
        width: textWidth,
        scaleX: 1,
        scaleY: 1
      });

      const timerTopOffset = Number(themeConfig['timer-top-offset'] || 9)
      const timerTopPosition = Number(top) + timerTopOffset;

      const timerTextConfig = {
        fontSize: timerFontSize,
        textAlign,
        fill,
        fontFamily,
        shadow: "black 0px 0px 1px",
        top: timerTopPosition,
        left,
        width: textWidth + (themeConfig['timer-width-offset'] || 0),
        scaleX: 1,
        scaleY: 1,
        visibility: false,
        data: {
          machineId: machine.id,
          remainingSeconds: machine.remainingSeconds,
          type: 'timer',
        }
      };
      let timerText1 = new fabric.Textbox('', timerTextConfig);
      let timerText2 = new fabric.Textbox('', timerTextConfig);
      let timerText3 = new fabric.Textbox('', timerTextConfig);
      let timerText4 = new fabric.Textbox('', timerTextConfig);

      group = new fabric.Group([obj, text, timerText1, timerText2, timerText3, timerText4]);

    } else {
      group = new fabric.Group([obj]);
    }

    // set the properties of the new group
    group.set({
      scaleX: 1,
      scaleY: 1,
      width: gridWidth,
      height: gridWidth,
      angle,
      lockRotation: true,
      lockScalingFlip: true,
      isMachineGroup: true,
      isNew: true,
      machineStatus,
      machineName,
      machineNumber,
      machineId,
      canvasType: 'machine',
      selectable: false,
      hoverCursor: 'default',
      zIndex
    });

    let scaleWidth = (Math.round(scaleX) * gridWidth) - 1;
    let scaleHeight = (Math.round(scaleX) * gridWidth) - 1;
    group.scaleToWidth(scaleWidth, true);
    group.scaleToHeight(scaleHeight, true);

    // finally adds the new group to the board
    canvas.add(group);
    checkCanvasSize(group);
    sortCanvas();
    completeAssetLoad();
  });
}

function sortCanvas() {
  let objectsToSort = [];
  canvas.forEachObject((obj) => {
    if (obj.zIndex) {
      objectsToSort.push(obj);
    }
  });

  objectsToSort.sort((a, b) => {
    if (a.zIndex < b.zIndex) {
      return -1;
    } else if (a.zIndex > b.zIndex) {
      return 1;
    }
    return 0;
  });

  objectsToSort.forEach((obj) => {
    obj.moveTo(obj.zIndex);
  });

  canvas.renderAll();
}

function isActive(statusId) {
  return statusId && ["in_use", "almost_done", "lucky_cycle"].includes(statusId && statusId.toLowerCase());
}

function statusColor(status, themeConfig) {

    // Return status colors defined in theme.json -or- defaultColors -or- fallbackColors
    if (status !== undefined) {
      status = status.toUpperCase();
    } else {
      status = "INIT";
    }

    // TODO: Check the remainingSeconds to change the status to ALMOST_DONE.
    // We don't do that now because the control sends an updated remainingSeconds every minute, and that value may not be 60 seconds less than the previous value.

    const fallbackColors = ["#c6cccf", "#999d9e"];
    const defaultStatusList = [
      {
        label: "available",
        status: ["AVAILABLE"],
        colors: ["#45b854", "#128521"],
        in_legend: true
      },
      {
        label: "in use",
        status: ["IN_USE", "ALMOST_DONE", "LUCKY_CYCLE", "READY_TO_START", "DOOR_OPEN"],
        colors: ["#f3a537", "#c07204"],
        in_legend: true
      },
      {
        label: "complete",
        status: ["COMPLETE"],
        colors: ["#2a8bda", "#0058a7"],
        in_legend: true
      },
      {
        label: "error",
        status: ["ERROR"],
        colors: ["#D0011B", "#a90015"],
        in_legend: true
      },
      {
        label: "offline",
        status: ["DEFAULT", "UNKNOWN", "NETWORK_ERROR", "UNAVAILABLE", "INIT"],
        colors: ["#c6cccf", "#93999c"],
        in_legend: true
      }
    ];

    let statusList;

    if (themeConfig.status) {
      statusList = themeConfig.status;
    } else {
      statusList = defaultStatusList;
    }

    function findStatus(status, statusList) {
      return statusList.find(item => {
        return item.status.includes(status);
      });
    }

    // Return the correct colors to use
    if (findStatus(status, statusList)) {
      return findStatus(status, statusList).colors;
    }
    if (findStatus("DEFAULT", statusList)) {
      return findStatus("DEFAULT", statusList).colors;
    }
    return fallbackColors;
}

function createLayout(url, left, top, scaleX, scaleY, angle) {
  let self = this;
  startAssetLoad();

  fabric.Image.fromURL(url, function(img) {
    let oImg = img.set({
      id: 'layout',
      left,
      top,
      scaleX,
      scaleY,
      angle,
      selectable: false,
      ignoreOnHover: true,
      hoverCursor: 'default',
      zIndex: 0
    });
    canvas.add(oImg);
    oImg.sendToBack();
    checkCanvasSize(oImg);
    completeAssetLoad();
  }, null, function(error) {
    console.warn('Failed to load layout image:', url, error);
    completeAssetLoad();
  });
}

function createLabel(label) {
  let text = new fabric.Textbox(label.labelText, {
    top: label.labelY,
    left: label.labelX,
    scaleX: label.labelScaleX,
    scaleY: label.labelScaleY,
    fontFamily: label.labelFont || "Helvetica",
    fontSize: label.labelFontSize || 10,
    fontWeight: label.labelWeight || "",
    fontStyle: label.labelStyle || "",
    underline: label.labelUnderline || "",
    angle: label.labelAngle,
    textAlign: "left",
    fill: label.labelColor,
    backgroundColor: label.labelBgColor,
    width: label.width,
    canvasType: 'label',
    selectable: false,
    hoverCursor: 'default',
    zIndex: label.zIndex || 1000,
  });
  canvas.add(text);
  sortCanvas();
  checkCanvasSize(text);
}

function checkCanvasSize(obj) {

  // let top = obj.top;
  // let bottom = obj.top + (obj.height * obj.scaleY);
  // let left = obj.left;
  // let right = obj.left + (obj.width * obj.scaleX);

  let bounds = obj.getBoundingRect(); // height, left, top, width;
  let top = bounds.top;
  let bottom = bounds.top + bounds.height;
  let left = bounds.left;
  let right = bounds.left + bounds.width;

  if (roomSettings.canvas.top === null || top < roomSettings.canvas.top) {
    roomSettings.canvas.top = top;
  }
  if (roomSettings.canvas.left === null || left < roomSettings.canvas.left) {
    roomSettings.canvas.left = left;
  }
  if (roomSettings.canvas.right === null || right > roomSettings.canvas.right) {
    roomSettings.canvas.right = right;
  }
  if (roomSettings.canvas.bottom === null || bottom > roomSettings.canvas.bottom) {
    roomSettings.canvas.bottom = bottom;
  }
}

function createImage(s3ImageUrl, filename, left, top, scaleX, scaleY, angle, zIndex, selectable = true, ignoreOnHover = false) {
  let path = `${s3ImageUrl}/rooms/${filename}`;
  startAssetLoad();

  fabric.Image.fromURL(path, (imageObject) => {
    let options = {
      id: 'image',
      left,
      top,
      scaleX: scaleX ? scaleX : 1,
      scaleY: scaleY ? scaleY : 1,
      angle,
      ignoreOnHover: true,
      selectable: false,
      zIndex,
      filename,
    };
    imageObject.set(options);
    canvas.add(imageObject);
    canvas.moveTo(imageObject, zIndex);
    sortCanvas();
    checkCanvasSize(imageObject);
    completeAssetLoad();
  }, null, (error) => {
    console.warn('Failed to load image:', path, error);
    completeAssetLoad();
  });
}

// Resize the canvas to remove extra white space
function canvasSizeUpdate() {
  if (roomSettings.canvasResize) {
    // We remove padding from the top and bottom if there is a background image
    if (roomSettings.hasBackgroundImage) {
      roomSettings.canvas.padding = 0;
    }

    let topOffset = -1 * (roomSettings.canvas.top - roomSettings.canvas.padding);
    if (topOffset > 0) topOffset = 0; // Top cannot be out of bounds

    let bottom = roomSettings.canvas.bottom;
    if (bottom > 800) bottom = 800; // Bottom cannot be out of bounds

    let adjustedHeight = parseInt(bottom + topOffset + roomSettings.canvas.padding);
    if (adjustedHeight > 800) adjustedHeight = 800;

    document.getElementById('c').style.marginTop = topOffset + 'px'; // Adjust the top
    document.getElementById('canvas-container').style.height = adjustedHeight + 'px'; // Adjust the height
    document.getElementById('canvas-container').style.backgroundColor = roomSettings.backgroundColor || "#fff"; // Match the canvas background color
  }

  // Show the canvas container
  document.getElementById('canvas-container').style.display = 'block';
  document.getElementById('room-view').style.display = 'block';
  document.getElementById('loader').style.display = 'none';
}

export default {
  name: "Room",
  props: {
    id: Number,
    roomId: Number,
    gridSizePx: Number,
    roomLabelMeta: Array,
    roomName: String,
    roomLogo: String
  },
  data() {
    return {
      showClock: false,
      showLegend: false,
      showLeftColumn: false,
      s3ImagePath: '',
    };
  },
  mounted() {
    // Store reference to this component for use in asset loading callbacks
    vueComponentInstance = this;

    $container = this.$refs.container;
    canvas = new fabric.Canvas("c", {
      selection: false,
      enableRetinaScaling: false
    });

        // Fix for fabric.js 5.3.1 textBaseline issue
    // Override CanvasRenderingContext2D textBaseline setter to prevent invalid values
    const originalTextBaselineDescriptor = Object.getOwnPropertyDescriptor(CanvasRenderingContext2D.prototype, 'textBaseline');
    if (originalTextBaselineDescriptor && originalTextBaselineDescriptor.set) {
      Object.defineProperty(CanvasRenderingContext2D.prototype, 'textBaseline', {
        get: originalTextBaselineDescriptor.get,
        set: function(value) {
          // Convert invalid 'alphabetical' to valid 'alphabetic'
          if (value === 'alphabetical') {
            value = 'alphabetic';
          }
          originalTextBaselineDescriptor.set.call(this, value);
        }
      });
    }

    this.timerUpdate();
  },
  beforeDestroy() {
    // Clean up references when component is destroyed
    if (vueComponentInstance === this) {
      vueComponentInstance = null;
      latestMachineData = null;
      machineUpdateNeeded = false;
    }
  },
  methods: {
    roomUpdate(room, machines, config) {
      let self = this;

      // Reset canvas bounds for new room load
      resetCanvasBounds();

      // Reset machine update flags for new room load
      machineUpdateNeeded = false;
      latestMachineData = null;

      this.showClock = config.showClock;
      this.showLegend = config.showLegend;
      this.showLeftColumn = this.showClock || this.showLegend;
      roomSettings.canvasResize = config.canvasResize;
      this.s3ImagePath = config.s3ImagePath;
      this.themeConfig = config.themeConfig;

      // Only init the clock if we need to show it
      if (this.showClock && !this.clockInitialized) {
        setTimeout(() =>{
          $("#clock").thooClock({
            size: 180,
            secondHandColor: "#cc0000"
          });
          this.clockInitialized = true;
        }, 1000);
      }

      let themeConfig = config.themeConfig;

      if (room.backgroundColor) {
        canvas.set('backgroundColor', room.backgroundColor);
        roomSettings.backgroundColor = room.backgroundColor;
      }

      if (themeConfig.background) {
        roomSettings.background = themeConfig.background;
      }

      if (room.roomCustomImageUrl) {
        // Draw background image
        createLayout(room.roomCustomImageUrl, room.washAlertXAxis, room.washAlertYAxis, room.washAlertScaleX, room.washAlertScaleY, room.washAlertAngle);
        roomSettings.hasBackgroundImage = true;
      }

      // if (room.washAlertGridlinesOnBg) {
      //   // Draw Canvas Grid
      //   createGrid(this.gridSizePx);
      // }

      // Draw machines
      for (let i in machines) {
        if (machines[i].washAlertIsVisible && machines[i].machineNumber) {
          createMachine(machines[i], machines[i].statusId, this.themeConfig);
        }
      }
      let s3ImageUrl = room.s3ImagePath;

      // Draw Canvas labels
      if (room.roomLabelMeta) {
        room.roomLabelMeta.forEach((item) => {
          if (item.filename) {
            const { filename, positionX, positionY, scaleX, scaleY, angle, zIndex } = item;
            createImage(
              s3ImageUrl,
              filename,
              positionX,
              positionY,
              scaleX,
              scaleY,
              angle,
              zIndex,
            );
          } else if (item.type === undefined || item.type === "label" || item.type === "text") {
            let txt = item;
            createLabel(item);
          }
        });
      }

      if (window.location.href.indexOf("mode=tv") != -1) {
        $(window).resize(function() {
          canvas.setDimensions({width: window.innerHeight - 80, height: window.innerHeight - 80});
          canvas.setZoom((window.innerHeight - 80) / self.gridSizePx);
        });

        canvas.setDimensions({width: window.innerHeight - 80, height: window.innerHeight - 80});
        canvas.setZoom((window.innerHeight - 80) / this.gridSizePx);
      }

      sortCanvas();
      canvas.renderAll();

      // Request canvas resize after all assets are loaded
      requestCanvasResize();
    },

    timerUpdate() {
      // Any status updates will trigger a change to the timer in the `machineUpdate` function.
      // All this function cares about are `isActive` machines that need their timer updated.
      if (timerObject !== undefined) {
        clearInterval(timerObject);
      }

      timerObject = setInterval(() => {
        canvas.forEachObject((obj) => {
          if (obj && obj.canvasType && obj.canvasType == 'machine' && isActive(obj.machineStatus)) {
            obj.remainingSeconds = parseInt(obj.remainingSeconds) - 1;

            // Change status to ALMOST_DONE if remaining seconds is less than 4 minutes
            if (obj.remainingSeconds < almostDoneThreshold) {
              obj.statusId = "ALMOST_DONE";
            }

            let duration = moment.duration(obj.remainingSeconds, "seconds");
            let seconds = duration.seconds();
            let minutes = parseInt(duration.minutes()) + (parseInt(duration.hours()) * 60)
            let timerText = _.filter(obj._objects, {type: 'textbox', data: {type: 'timer'}});
            let newText = `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

            if (duration < 0) {
              timerText.forEach((text) => {
                text.set('text', "--:--");
              });
            } else if (newText) {
              timerText.forEach((text) => {
                text.set('text', newText);
              });
            } else {
              console.log('*** no text')
            }
          }
        });
        canvas.renderAll();
      }, 1000);

    },

    // This function is called from `Home.vue` every time we get an update from Firebase.
    machineUpdate(machines) {
      // Store latest machine data for use after asset loading completes
      latestMachineData = machines;

      // If assets are still loading, defer the update until they complete
      if (pendingAssetLoads > 0) {
        machineUpdateNeeded = true;
        return;
      }

      // Request canvas resize (will happen after all pending assets load)
      requestCanvasResize();

      // Loop through every machine and update things
      for (var i in machines) {
        let machine = machines[i];

        canvas.forEachObject((obj) => {
          // Find this machine on the canvas.
          if (obj && obj.canvasType && obj.canvasType == 'machine' && obj.machineId == machine.id) {

            // Skip any machines without an update flag
            if (!machine.hasUpdate) {
              return;
            }

            // Reset the update flag
            machine.hasUpdate = false;

            // Update the visibility of the timer text and the remaining seconds
            let timerText = _.filter(obj._objects, {type: 'textbox', data: {type: 'timer'}});
            timerText.forEach((text) => {
              text.set('visible', isActive(machine.statusId));
            })

            obj.remainingSeconds = machine.remainingSeconds;

            // Always update the status color to ensure consistency
            let oldColor = statusColor(obj.get('machineStatus'), this.themeConfig);
            let newColor = statusColor(machine.statusId, this.themeConfig);

            obj.set('machineStatus', machine.statusId);

            // sets the color of the svg object to the right status color
            if (obj._objects[0].fill == oldColor[0] || obj._objects[0].id == 'fill-#ccc') {
              obj._objects[0].set({ fill: newColor[0] });
            } else if (obj._objects[0].fill == oldColor[1] || obj._objects[0].id == 'fill-#aaa') {
              obj._objects[0].set({ fill: newColor[1] });
            }

            if (obj._objects[0].stroke == oldColor[0] || obj._objects[0].id == 'stroke-#ccc') {
              obj._objects[0].set({ stroke: newColor[0] });
            } else if (obj._objects[0].stroke == oldColor[1] || obj._objects[0].id == 'stroke-#aaa') {
              obj._objects[0].set({ stroke: newColor[1] });
            }

            // also check sub shapes to the right status color
            for (x in obj._objects[0]._objects) {
              if (obj._objects[0]._objects[x].fill == oldColor[0] || obj._objects[0]._objects[x].id == 'fill-#ccc') {
                obj._objects[0]._objects[x].set({ fill: newColor[0] });
              } else if (obj._objects[0]._objects[x].fill == oldColor[1] || obj._objects[0]._objects[x].id == 'fill-#aaa') {
                obj._objects[0]._objects[x].set({ fill: newColor[1] });
              }

              if (obj._objects[0]._objects[x].stroke == oldColor[0] || obj._objects[0]._objects[x].id == 'stroke-#ccc') {
                obj._objects[0]._objects[x].set({ stroke: newColor[0] });
              } else if (obj._objects[0]._objects[x].stroke == oldColor[1] || obj._objects[0]._objects[x].id == 'stroke-#aaa') {
                obj._objects[0]._objects[x].set({ stroke: newColor[1] });
              }
            }
          }
        });
      }
      canvas.renderAll();
    }
  }
};
</script>

<style scoped>
.center {
  text-align: center;
}

#room-view {
  display: none;
}

#canvas-container {
  overflow:hidden;
  border:1px solid #ccc;
  max-width:800px;
  max-height:800px;
  margin: 0 auto;
  display:none;
  opacity: 0.85;
}

canvas {
  top: 0;
  position: absolute;
}

#info {
  display: none;
}

.tv-mode #info {
  display: block;
}

#wa-container {
  position: absolute;
  height: 801px;
  overflow: visible;
  padding: 0;
  /* z-index: 100;
  position:relative; */
}

#legend h4 {
  font-weight: bold;
  margin: 16px;
  padding: 0.125em 0.5em;
  color: white;
  border-radius: 4px;
}

.available {
  background: #45B854;
  text-shadow: 2px 2px #359742;
  box-shadow: 2px 2px 6px 1px #359742;
}

.in_use {
  background: #F5A623;
  text-shadow: 2px 2px #c98729;
  box-shadow: 2px 2px 6px 1px #c98729;
}

.complete {
  background: #2a8bda;
  text-shadow: 2px 2px #2671b4;
  box-shadow: 2px 2px 6px 1px #2671b4;
}

.error {
  background: #D0011B;
  text-shadow: 2px 2px #a90015;
  box-shadow: 2px 2px 6px 1px #a90015;
}

.offline {
  background: #c6cccf;
  text-shadow: 2px 2px #a7acaf;
  box-shadow: 2px 2px 6px 1px #a7acaf;
}

.rotating {
  transform-origin: center 47px;
  animation: rotating 2s linear infinite;
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Room.vue